/**
 * @fileoverview GET handler for the "/engagement/content_blocks/content" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementContentBlocksContent } from "./constants";
import type { EngagementContentBlocksContentResult } from "./types";

export const getEngagementContentBlocksContent = reactQueryFetcherAdapter(
  engagementContentBlocksContent,
  (signal: AbortSignal, contentBlockNames: string[]): Promise<EngagementContentBlocksContentResult> => {
    return fetch("/engagement/content_blocks/content", "GET", { names: contentBlockNames }, { signal });
  }
);
